import { Wordmark } from '../Wordmark.tsx';
import { GettingStarted } from './GettingStarted.tsx';
import { ToolGuides } from './ToolGuides.tsx';
import { ApiReference } from './ApiReference.tsx';
import { Billing } from './Billing.tsx';
import { About } from './About.tsx';
import { Privacy } from './Privacy.tsx';
import { Terms } from './Terms.tsx';

const SECTIONS = [
  { slug: 'getting-started', label: '快速开始', icon: '🚀' },
  { slug: 'tools', label: '工具接入', icon: '🔧' },
  { slug: 'api', label: 'API 说明', icon: '📡' },
  { slug: 'billing', label: '计费说明', icon: '💰' },
  { slug: 'about', label: '关于我们', icon: '📖' },
  { slug: 'privacy', label: '隐私协议', icon: '🔐' },
  { slug: 'terms', label: '服务条款', icon: '📋' },
] as const;

function renderContent(section: string): JSX.Element {
  switch (section) {
    case 'tools': return <ToolGuides />;
    case 'api': return <ApiReference />;
    case 'billing': return <Billing />;
    case 'about': return <About />;
    case 'privacy': return <Privacy />;
    case 'terms': return <Terms />;
    default: return <GettingStarted />;
  }
}

export function DocsLayout({ section }: { readonly section: string }): JSX.Element {
  return (
    <div className="min-h-screen bg-linen">
      <header className="ghost-b sticky top-0 z-50 bg-linen/85 backdrop-blur-md">
        <div className="flex h-14 items-center gap-6 px-6">
          <a href="/" className="flex items-center gap-2">
            <Wordmark />
          </a>
          <span className="text-ink-subtle">/</span>
          <span className="text-[14px] font-medium text-ink">文档</span>
          <div className="flex-1" />
          <a
            href="/"
            className="text-[13px] text-ink-subtle hover:text-ink transition-colors"
          >
            ← 返回首页
          </a>
        </div>
      </header>

      <div className="flex">
        <aside className="sticky top-14 hidden h-[calc(100vh-56px)] w-60 shrink-0 overflow-y-auto bg-butter/20 p-5 md:block">
          <nav>
            <ul className="space-y-1">
              {SECTIONS.map((s) => (
                <li key={s.slug}>
                  <a
                    href={`#docs/${s.slug}`}
                    className={`flex items-center gap-2.5 rounded-lg px-3 py-2 text-[14px] transition-colors ${
                      section === s.slug
                        ? 'bg-claude/10 font-semibold text-claude'
                        : 'text-ink-muted hover:bg-butter/50 hover:text-ink'
                    }`}
                  >
                    <span className="text-[14px]">{s.icon}</span>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <main className="flex-1 px-8 py-10 md:px-16">
          <div className="mx-auto max-w-3xl">
            {renderContent(section)}
          </div>
        </main>
      </div>
    </div>
  );
}
